<template>
  <div>
    <HeadingExtraSmall
      :class="$style.marginBottom"
      weight="semibold"
    >
      {{ control.label }}
      <IconTooltip :tooltipContainerClass="$style.tooltip">
        <p>
          {{ control.tooltip.variables.message }}
        </p>
      </IconTooltip>
    </HeadingExtraSmall>
    <SegmentedButton
      name="segmentedbutton"
      :options="getDisplayOptions(control)"
      :value="handleDisplayValue(control)"
      @input="handleChangeValue"
    />
  </div>
</template>

<script>
import {
  HeadingExtraSmall,
  SegmentedButton,
} from '@jumpcloud/ui-components';
import DynamicControlsMixin from 'components/DynamicControls/mixins/DynamicControlsMixin';
import IconTooltip from 'components/Tooltip/IconTooltip';

export default {
  name: 'DynamicControlsSegmentedButton',

  components: {
    HeadingExtraSmall,
    IconTooltip,
    SegmentedButton,
  },

  mixins: [DynamicControlsMixin],

  props: {
    value: {
      required: true,
      type: String,
    },
  },

  methods: {
    getDisplayOptions(control) {
      const { displayOptions, displayType } = control;
      const displayTypeCaps = displayType.toUpperCase();

      if (displayOptions && displayOptions[displayTypeCaps]) {
        const finalDisplayOptions = [];
        displayOptions[displayTypeCaps].forEach((item) => {
          finalDisplayOptions.push({
            label: item.text,
            value: item.value,
          });
        });
        return finalDisplayOptions;
      }
      return displayOptions;
    },

    getDisplayValue(control) {
      const options = this.getDisplayOptions(control);
      const displayValue = options.find(option => option.value === this.value);
      return displayValue.value;
    },

    handleChangeValue(value) {
      const handler = this.control.handleValueChange || this.handleChange;
      return handler(value);
    },

    handleDisplayValue(control) {
      const handler = control.getDisplayValue || this.getDisplayValue;
      return handler(control);
    },
  },
};
</script>
<style module>
.marginBottom {
  margin-bottom: 4px !important;
}

.tooltip {
  margin-left: 0.3rem;
  margin-right: 0.6rem;
  position: relative;
  top: 0;
}
</style>
